import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/index/index'
import community from '@/pages/community/community'
import neighbourhood from "../pages/neighbourhood/neighbourhood";
import family from "../pages/family/family";
import trade from "../pages/trade/trade";
import module from "../pages/module/module";
import news from "../pages/news/news";
import foundingTeam from "../pages/about/foundingTeam";
import corporatehonors from "../pages/about/corporatehonors";


import synopsis from "../pages/about/synopsis";
import successCase from "../pages/about/successCase";
import videoGroup from "../pages/about/videogroup";
import newsContent from "../pages/news/newsContent";
import matter from "../pages/matter/matter";
Vue.use(Router)

export default new Router({
  linkActiveClass: "on",
  mode: 'history',
  base: '/base/',
  routes: [
    //首页
    {
      path: '/',
      name: 'home',
      component: home
    },
    //智慧社区 
    {
      path: '/community',
      name: 'community',
      component: community
    },
    //智慧小区
    {
      path: '/neighbourhood',
      name: 'neighbourhood',
      component: neighbourhood
    },
    //智慧家庭
    {
      path: '/family',
      name: 'family',
      component: family
    },
    //智慧商业
    {
      path: '/trade',
      name: 'trade',
      component: trade
    },
    // 物商模块
    {
      path: '/matter',
      name: 'matter',
      component: matter
    },
    //联网模块
    {
      path: '/module',
      name: 'module',
      component: module
    },
    //新闻资讯
    {
      path: '/news',
      name: 'news',
      component: news
    },
    //新闻内容
    {
      path: '/newsContent/:id',
      name: 'newsContent',
      component: newsContent
    },
    //关于我们 (平台简介)
    {
      path: '/about/synopsis',
      name: 'synopsis',
      component: synopsis,

    },
    //关于我们 (案例分享)
    {
      path: '/about/successCase',
      name: 'successCase',
      component: successCase,

    },
    //关于我们 (视频荟萃)
    {
      path: '/about/videoGroup',
      name: 'videoGroup',
      component: videoGroup,

    },
    //关于我们 (创始团队)
    {
      path: '/about/foundingTeam',
      name: 'foundingTeam',
      component: foundingTeam,

    },
    {
      path: '/about/corporatehonors',
      name: 'corporatehonors',
      component: corporatehonors,

    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js